module.exports = __webpack_public_path__ + "static/media/clothes_03.fb040bd8.svg";